<template>
  <a-modal
    title="关联客户"
    :visible="visible"
    @cancel="cancel"
    @ok="ok"
    :width="800"
    :confirmLoading="loading"
  >
    <ml-table
      :columns="columns"
      :dataSource="dataSource"
      size="small"
      rowKey="id"
      :pagination="pagination"
      :scroll="{ y: 400 }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      @change="onChange"
    />
  </a-modal>
</template>

<script>
import { CustomerServiceProxy } from '@/service-proxies/app-v2/masterlink-cps-client.service-proxies';
const customerService = new CustomerServiceProxy()
export default {
  data() {
    return {
      loading: false,
      visible: false,
      user: {},
      dataSource: [],
      selectedRowKeys: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: this.$t('page_ops_customer_customer_name'),
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        }
      ],
    }
  },
  methods: {
    onShow(data, ids) {
      this.visible = true;
      this.user = data;
      this.selectedRowKeys = ids;
      this.getData();
    },
    getData() {
      customerService.getSettingPageCustomer(undefined,this.pagination.current, '', this.pagination.pageSize).then(data=>{
        this.dataSource = data.records || [];
        this.pagination.total = data.total;
      })
    },
    onChange(pagination) {
      this.pagination.current = pagination.current;
      this.getData();
    },
    onSelectChange(val) {
      this.selectedRowKeys = val;
    },
    cancel() {
      this.visible = false;
    },
    ok() {
      this.loading = true;
      console.log(this.user, this.selectedRowKeys);
      customerService.updateCustomerUserRelation({userId: this.user.id, customerIds: this.selectedRowKeys}).then(data=>{
        this.$message.success('操作成功');
        this.$emit('update');
        this.cancel();
      }).finally(()=>{
        this.loading = false;
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
